import React from 'react';
import ADatePicker from 'antd-mobile/lib/date-picker';



export default class DatePicker extends ADatePicker {}